export default __webpack_public_path__ + "static/media/de.e5316ade.svg";